export const formatDateApi = (datestr) => {
    return  datestr.
            replace(/T/, ' ').
            replace(/-/g, '/').
            replace(/\..+/, '')
            // .
            // slice(0,-3);
}


export const  formatDateApiWithoutTime  = (datestr) => {
    return  datestr.
            replace(/T/, ' ').
            replace(/-/g, '.').
            // replace(/\..+/, '')
            slice(0,-9);
};

export const splitList = (str) => {
    const replaseStr = str.replace( /,/g,' ')
        .replace( /\r/g,' ')
        .replace( /\n/g,' ');
    return replaseStr.split(' ').filter( s => s !== "");
};

export const convertDataInColumn = (data, key, filter) => {
    return data.map(column => {
        if (column.hasOwnProperty(key)) {
            return filter(column[key], column, key)
        } else {
            return column
        }
    })
};

export const getServiceTitle = (service) => {
    return service ? 'Voice' : 'SMS';
}

export const formatLargeList = (array) => {
    return array && (array.length < 10 ? (array.join(', ')) : `${array.slice(0, 3).join(', ')}...`);
}

export const toStringDate = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');

    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
}